import { JobTitleMap } from "../../model/ticketEasy/jobTitleMapping/JobTitleMap";

export class JobTitleMappingCommand {
    message: JobTitleMap[];

    constructor(message: JobTitleMap[]) {
        this.message = message;
    }
}